module.exports = __webpack_public_path__ + "img/BDC3E9E1-19B7-4ABA-8B45-41693D938DC8-232-00000044612F7663-1.png";